import { PermissionKey } from '../models/permission';

export function permissionKeysForUrl(url: string): PermissionKey[] {
  const path = url.split(/[?#]/)[0];
  if (path === '/workspaces/connectors' || path.startsWith('/workspaces/connectors/')) {
    return ['workspaces', 'connectors'];
  }
  if (/^\/workspaces\/(list|workspace)(\/|$)/.test(path)) {
    return ['workspaces'];
  }
  if (path === '/vaults' || path.startsWith('/vaults/')) {
    return ['vaults'];
  }
  return [];
}
